import { Component, Input } from '@angular/core';
import { LanguageService, Language } from './language.service';

@Component({

    selector: 'syn-language',
    templateUrl: 'language.component.html'
})
export class LanguageComponent {

    @Input() showIcon = true;
    @Input() backgroundColor: string;
    @Input() iconColor: string;
    @Input() muted = true;

    language: Language;
    private _value: string;

    constructor(private languageService: LanguageService) { }

    get languageValue(): string {
        return this._value;
    }

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('language')
    set languageValue(value: string) {
        this._value = value;
        this.language = this.languageService.language(value);
    }

}
